import React from "react";

import { HTTP_EXCEPTION_MESSAGES } from "consts";

function serverDown(props) {
  return (
    <div className="internet_error">
      <div className="inner_ie">
        <div className="ie_img_holder">
          {/*?xml version="1.0" encoding="utf-8"?*/}
          {/* Generator: Adobe Illustrator 20.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  */}
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 405 178"
            style={{ enableBackground: "new 0 0 405 178" }}
            xmlSpace="preserve"
          >
            <style
              type="text/css"
              dangerouslySetInnerHTML={{
                __html:
                  "\n                      .ie0{fill:#DEE7EE;}\n                      .ie1{fill:#7D8F9F;}\n                      .ie2{fill:#FFFFFF;}\n                      .ie3{fill:#467CBE;}\n                    "
              }}
            />
            <g>
              <path
                className="ie0"
                d="M270.1,100.8H73.7c-9.9,0-17.9-8.1-17.9-17.9v0c0-9.9,8.1-17.9,17.9-17.9h196.4c9.9,0,17.9,8.1,17.9,17.9v0
                    C288,92.7,279.9,100.8,270.1,100.8z"
              />
            </g>
            <g>
              <path
                className="ie0"
                d="M292,168.6h-90.3c-9.9,0-17.9-8.1-17.9-17.9v0c0-9.9,8.1-17.9,17.9-17.9H292c9.9,0,17.9,8.1,17.9,17.9v0
                    C309.9,160.5,301.8,168.6,292,168.6z"
              />
            </g>
            <g>
              <path
                className="ie0"
                d="M300.2,46.3h-24.4c-9.9,0-17.9-8.1-17.9-17.9v0c0-9.9,8.1-17.9,17.9-17.9h24.4c9.9,0,17.9,8.1,17.9,17.9v0
                    C318.1,38.3,310.1,46.3,300.2,46.3z"
              />
            </g>
            <g>
              <rect
                x="0.3"
                y="166.5"
                className="ie1"
                width="405.3"
                height={2}
              />
            </g>
            <g>
              <g>
                <path
                  className="ie2"
                  d="M278,142H114c-5.5,0-10-4.5-10-10V30c0-5.5,4.5-10,10-10h164c5.5,0,10,4.5,10,10v102
                      C288,137.5,283.5,142,278,142z"
                />
                <path
                  className="ie1"
                  d="M278,143H114c-6.1,0-11-4.9-11-11V30c0-6.1,4.9-11,11-11h164c6.1,0,11,4.9,11,11v102
                      C289,138.1,284.1,143,278,143z M114,21c-5,0-9,4-9,9v102c0,5,4,9,9,9h164c5,0,9-4,9-9V30c0-5-4-9-9-9H114z"
                />
              </g>
              <g>
                <path
                  className="ie1"
                  d="M228.2,168.5H165l-0.3-0.4c-1.6-2.4-2.1-4.4-1.3-5.9c1.1-2.3,4.4-2.6,4.6-2.6l10.6,0c1.9-0.1,3.5-0.7,4.5-1.9
                      c2.1-2.3,2-6,2-6.1l0-9.6h2v9.5c0,0.1,0.2,4.5-2.5,7.5c-1.5,1.6-3.5,2.5-6,2.5H168c-0.6,0-2.3,0.4-2.9,1.5c-0.5,1,0.2,2.4,0.9,3.5
                      h61.7c0.6-0.3,1.7-1,1.8-2c0.1-0.8-0.6-1.8-1.9-2.8h-9.4c-0.2,0-5.2,0.2-8.6-2.9c-1.9-1.7-2.8-4.1-2.9-7.1V142h2v9.8
                      c0.1,2.4,0.8,4.3,2.3,5.6c2.8,2.6,7.1,2.4,7.2,2.4l10.1,0l0.3,0.2c2.1,1.6,3.1,3.2,2.9,4.8c-0.3,2.4-3,3.6-3.1,3.7L228.2,168.5z"
                />
              </g>
              <g>
                <g>
                  <circle className="ie3" cx="197.3" cy="80.5" r="25.2" />
                </g>
                <g>
                  <path
                    className="ie2"
                    d="M197,86.1L197,86.1c-1.2,0-2.2-1-2.2-2.2V67.7c0-1.2,1-2.2,2.2-2.2l0,0c1.2,0,2.2,1,2.2,2.2v16.1
                        C199.3,85.1,198.3,86.1,197,86.1z"
                  />
                </g>
                <g>
                  <path
                    className="ie2"
                    d="M197,97.6L197,97.6c-1.2,0-2.2-1-2.2-2.2v-2.9c0-1.2,1-2.2,2.2-2.2l0,0c1.2,0,2.2,1,2.2,2.2v2.9
                        C199.3,96.6,198.3,97.6,197,97.6z"
                  />
                </g>
              </g>
              <g>
                <path
                  className="ie1"
                  d="M275.6,135.6H116.5c-2.8,0-5-2.2-5-5V32.4c0-2.8,2.2-5,5-5h159.1c2.8,0,5,2.2,5,5v98.2
                      C280.6,133.3,278.3,135.6,275.6,135.6z M116.5,29.4c-1.7,0-3,1.3-3,3v98.2c0,1.7,1.3,3,3,3h159.1c1.7,0,3-1.3,3-3V32.4
                      c0-1.7-1.3-3-3-3H116.5z"
                />
              </g>
            </g>
          </svg>
        </div>
        <div className="ie_content">
          {props.data.status === 500 || props.data.status === 501 ? (
            <p className="num">Error {props.data.status}</p>
          ) : null}
          <p className="msg">
            {HTTP_EXCEPTION_MESSAGES[props.data.msg]
              ? HTTP_EXCEPTION_MESSAGES[props.data.msg]
              : props.data.msg}
            <br />
            Try again in sometime.
          </p>
        </div>
      </div>
    </div>
  );
}

export default serverDown;
